import 'core-js/features/reflect';
import 'zone.js/dist/zone';
// This will bypass the most of zone.js related stacktraces
import 'zone.js/dist/zone-error';
